import { isEmptyString } from 'helper';
import React from 'react';

interface ISectionLabel {
	label?: string;
}

export const SectionLabel = (props: ISectionLabel) => {
	const { label } = props;

	if (!isEmptyString(label)) {
		return <div className="font-bold text-lg mt-8">{label}</div>;
	}

	return null;
};
